import React, { useMemo, useState } from 'react';
import { Selection } from './components/Selection/Selection';
import { Deposit } from './components/Deposit/Deposit';
import { TransferType } from './TransferMoney.types';
import { Withdraw } from './components/Withdraw/Withdraw';
import { TransferAccount } from './components/TransferAccount/TransferAccount';
import { TransferMoneyContext } from './hooks/useTransferMoneyContext';

interface Props {
  clientId: string;
  accountId: string;
  accountName: string;
  managedAccountId: string;
  onClose(): void;
}

export const TransferMoney: React.FC<Props> = ({
  clientId,
  accountId,
  accountName,
  managedAccountId,
  onClose,
}) => {
  const [transferType, setTransferType] = useState<TransferType | null>(null);

  const context = useMemo(
    () => ({
      clientId,
      accountId,
      accountName,
      managedAccountId,
    }),
    [clientId, accountId, accountName, managedAccountId],
  );

  return (
    <TransferMoneyContext.Provider value={context}>
      {!transferType && (
        <Selection
          onSelection={_transferType => setTransferType(_transferType)}
          onClose={onClose}
        />
      )}

      {transferType === TransferType.Deposit && (
        <Deposit onClose={onClose} onBack={() => setTransferType(null)} />
      )}

      {transferType === TransferType.Withdraw && (
        <Withdraw onClose={onClose} onBack={() => setTransferType(null)} />
      )}

      {transferType === TransferType.TransferAccount && (
        <TransferAccount onClose={onClose} onBack={() => setTransferType(null)} />
      )}
    </TransferMoneyContext.Provider>
  );
};
